import * as React from 'react'
import { useLazyQuery } from '@apollo/react-hooks'
import debounce from 'lodash.debounce'

import {
  InstantSearchProps,
  Response,
  SearchQueryVariables,
} from '@thg-commerce/enterprise-components/Header'

import { InstantSearch as INSTANT_SEARCH_QUERY } from '../graphql/HeaderQueries.graphql'

export const InstantSearchInjector = (props: {
  children: (props: InstantSearchProps) => React.ReactNode
}) => {
  const [execSearchQuery, queryResult] = useLazyQuery<
    Response,
    SearchQueryVariables
  >(INSTANT_SEARCH_QUERY)
  const { data } = queryResult

  const debouncedExecSearchQuery = React.useMemo(
    () =>
      debounce((options: { variables: SearchQueryVariables }) => {
        execSearchQuery(options)
      }, 300),
    [execSearchQuery],
  )

  React.useEffect(() => {
    return () => {
      debouncedExecSearchQuery.cancel()
    }
  }, [debouncedExecSearchQuery])

  return (
    <React.Fragment>
      {props.children({
        data,
        execSearchQuery: debouncedExecSearchQuery,
      })}
    </React.Fragment>
  )
}
